import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

const sid = () => {
  let s = sessionStorage.getItem("kc_sid");
  if (!s) {
    s = crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2);
    sessionStorage.setItem("kc_sid", s);
  }
  return s;
};

const roleFromToken = () => {
  try {
    const t = localStorage.getItem("kc_token");
    if (!t) return "guest";
    return JSON.parse(atob(t.split(".")[1].replace(/-/g, "+").replace(/_/g, "/"))).role || "guest";
  } catch {
    return "guest";
  }
};

let buf = [];
let timer = null;
let last = { key: "", t: 0 };

const flush = () => {
  if (!buf.length) return;
  const body = JSON.stringify({
    session_id: sid(),
    device: window.innerWidth < 768 ? "mobile" : "desktop",
    role: roleFromToken(),
    events: buf.splice(0),
  });
  try {
    const ok = navigator.sendBeacon(`${API}/api/analytics/events`, new Blob([body], { type: "application/json" }));
    if (!ok) throw new Error("beacon refused");
  } catch {
    axios.post(`${API}/api/analytics/events`, JSON.parse(body)).catch(() => {});
  }
};

export const track = (event, meta = {}) => {
  const key = event + JSON.stringify(meta);
  const now = Date.now();
  if (key === last.key && now - last.t < 800) return;
  last = { key, t: now };
  buf.push({ event, meta });
  clearTimeout(timer);
  timer = setTimeout(flush, 3000);
};

window.addEventListener("pagehide", flush);
